import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';

import { catchError, delay, map, tap } from 'rxjs/operators';

import BaseService from 'libs/shared-lib1/src/lib/shared/base.service';
import { Movie } from '../../models/movie';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Test9Service {
  constructor(private http: HttpClient, private baseService: BaseService) {
    this.baseService.initializeBaseUrl(
      'https://localhost:7102',
      'https://itai-net-core.azurewebsites.net',
      environment
    );
  }

  getMovies(): Observable<Array<Movie>> {
    let retVal: Movie[] = new Array<Movie>();

    this.baseService.initializeBaseUrl(
      'https://localhost:7102',
      'https://itai-net-core.azurewebsites.net',
      environment
    );

    //https://localhost:7102/api/ngrx/GetNgrxMovies_realSqlData

    var url = this.baseService.baseUrl + '/api/ngrx/GetNgrxMovies_realSqlData';

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        retVal = this.mapResponseToRetVal(response.value);

        return retVal;
      }),
      catchError((error: HttpErrorResponse) => {
        let errroAsString: string = error.message;

        //https://stackoverflow.com/questions/68655492/throwerrorerror-is-now-deprecated-but-there-is-no-new-errorhttperrorresponse
        return throwError(() => errroAsString);
      })
    );
  }

  mapResponseToRetVal(arrayOfComplexDataBOFromAPi: any[]): Movie[] {
    let retVal: Movie[] = new Array<Movie>();

    var arrayLength = arrayOfComplexDataBOFromAPi.length;

    for (var i = 0; i < arrayLength; i++) {
      let temp: Movie = new Movie();

      let currentResultFromApi: any = arrayOfComplexDataBOFromAPi[i];

      temp.Id = currentResultFromApi.id;
      temp.Name = currentResultFromApi.name;
      temp.UserName = currentResultFromApi.userName + ' ' + i;
      temp.Earning = currentResultFromApi.earning;
      temp.ReleaseDate = currentResultFromApi.releaseDate;

      // temp.releaseNo = currentResultFromApi.releaseNumber;

      retVal.push(temp);
    }

    return retVal;
  }

  addMovie(movie: Movie): Observable<Movie> {
    var url = this.baseService.baseUrl + 'api/ngrx/AddNgrxMovie_realSqlData';

    return this.http.post<Movie>(url, movie).pipe(
      map((responseFromApi) => {
        let retVal: Movie = mapResponseToMovie(responseFromApi);
        //return of(retVal);

        return retVal;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error(error);

        let errroAsString: string = error.message;

        //https://stackoverflow.com/questions/68655492/throwerrorerror-is-now-deprecated-but-there-is-no-new-errorhttperrorresponse
        return throwError(() => errroAsString);
      })
    );
  }

  deleteMovie(movieId: number) {
    var url =
      this.baseService.baseUrl +
      'api/ngrx/DeleteNgrxMovie_realSqlData?id=' +
      movieId;

    //var url2 = `${this.url}/${movieId}`;

    return this.http.delete(url).pipe(
      map((responseFromApi) => {
        let retVal: Movie = mapResponseToMovie(responseFromApi);
        //return of(retVal);

        return retVal;
      }),

      delay(2000),

      catchError((error: HttpErrorResponse) => {
        console.error(error);

        let errroAsString: string = error.message;

        //https://stackoverflow.com/questions/68655492/throwerrorerror-is-now-deprecated-but-there-is-no-new-errorhttperrorresponse
        return throwError(() => errroAsString);
      })
    );
  }

  updateMovie(movie: Movie): Observable<Movie> {
    var url =
      this.baseService.baseUrl +
      'api/ngrx/UpdateNgrxMovie_realSqlData/' +
      movie.Id;

    return this.http.put<Movie>(url, movie).pipe(
      map((responseFromApi) => {
        let retVal: Movie = mapResponseToMovie(responseFromApi);
        return retVal;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error(error);

        let errroAsString: string = error.message;

        //https://stackoverflow.com/questions/68655492/throwerrorerror-is-now-deprecated-but-there-is-no-new-errorhttperrorresponse
        return throwError(() => errroAsString);
      })
    );
  }
}
function mapResponseToMovie(responseFromApi: any): Movie {
  let retVal: Movie = new Movie();

  if (responseFromApi && responseFromApi.value) {
    retVal.Earning = responseFromApi.value.earning;
    retVal.Id = responseFromApi.value.id;
    retVal.Name = responseFromApi.value.name;
    retVal.ReleaseDate = responseFromApi.value.releaseDate as Date;
    retVal.UserName = responseFromApi.value.userName;
  }

  return retVal;
}
